import type { RbacPermission, RbacResource } from '@gozoki/api-types'

/**
 * Libellés de la taxonomie v1. Les écrans Rôles sont désormais full v2 (matrice, détail et liste ne
 * montrent plus que `permissionsV2`) : ces deux tables ne servent plus qu'à `~/utils/permissionLabels`,
 * pour nommer un tuple v1 dans un tooltip de refus tant que le régime hérité existe.
 */
export const RBAC_RESOURCE_LABELS: Record<RbacResource, string> = {
  dashboard: 'Tableau de bord',
  today: "Aujourd'hui",
  carts: 'Paniers',
  categories: 'Catégories',
  products: 'Produits',
  users: 'Utilisateurs',
  promos: 'Campagnes promo',
  'work-concil': 'Partenariats CE',
  notifications: 'Notifications',
  stores: 'Boutiques',
  accounting: 'Comptabilité',
  quality: 'Qualité',
  'cart-control': 'Contrôle panier',
  'daily-sales': 'Ventes journalières',
  sellers: 'Vendeurs',
  cameras: 'Caméras',
  'camera-views': 'Vues caméras',
  sensors: 'Capteurs',
  'hr-planning': 'RH & Planning',
  'real-estate': 'Foncier & travaux',
  roles: 'Rôles',
  'platform-stocks': 'Stock Plateforme',
  'visio-reviews': 'Contrôle Visio',
}

export const RBAC_PERMISSION_TYPE_LABELS: Record<RbacPermission, string> = {
  read: 'Voir',
  edit: 'Éditer',
}
